import { RootState } from '@cp/src/store';
import { LoadingIcon } from '@navi/web-ui/lib/icons';
import { Button } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { IAnomalySubmitCta } from '../../types';

const AnomalySubmitCta = (props: IAnomalySubmitCta) => {
  const { disabled, onSubmit } = props;
  const isSubmitting = useSelector((state: RootState) => state?.anomalyTracker?.actionLoading);

  return (
    <div className="p-4 border-0 border-t border-solid border-[var(--navi-color-gray-border)]">
      <Button disabled={disabled || isSubmitting} fullWidth onClick={onSubmit} variant="primary">
        {isSubmitting ? <LoadingIcon color="white" size="sm" /> : 'Submit'}
      </Button>
    </div>
  );
};

export default AnomalySubmitCta;
